import React, { useState } from "react";
import { Smartphone, X } from "lucide-react";
import { useI18n } from "../lib/i18n";

/**
 * Sticky bottom banner — appears on mobile only, prompts users to download the app.
 * Dismissed state persisted to localStorage so it doesn't reappear during the same session.
 */
export default function MobileAppBanner() {
  const { lang } = useI18n();
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return !window.localStorage.getItem("cartal_app_banner_dismissed");
  });

  if (!visible) return null;

  const dismiss = () => {
    if (typeof window !== "undefined") window.localStorage.setItem("cartal_app_banner_dismissed", "1");
    setVisible(false);
  };

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0a0a0a] text-[#f1ecdf] shadow-[0_-12px_28px_-8px_rgba(0,0,0,0.35)] border-t border-[#c9a55c]/30"
      data-testid="mobile-app-banner"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="w-10 h-10 rounded-lg bg-[#c9a55c]/15 border border-[#c9a55c]/50 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-[#d4b56e]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium leading-tight">{lang === "ar" ? "حمّل تطبيق كارتال" : "Get the CARTAL app"}</div>
          <div className="text-[11px] text-[#f1ecdf]/70">{lang === "ar" ? "تجربة أسرع وإشعارات فورية" : "Faster experience & instant alerts"}</div>
        </div>
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <span
            className="px-2.5 py-1.5 rounded-lg bg-[#c9a55c]/30 border border-[#c9a55c]/60 text-[#d4b56e] text-[11px] font-bold tracking-wide select-none"
            data-testid="banner-coming-soon"
          >
            {lang === "ar" ? "قريباً جداً" : "Coming soon"}
          </span>
          <button
            onClick={dismiss}
            className="w-7 h-7 rounded-full hover:bg-[#f1ecdf]/10 flex items-center justify-center"
            data-testid="banner-dismiss"
            aria-label={lang === "ar" ? "إغلاق" : "Dismiss"}
          >
            <X className="w-4 h-4 text-[#f1ecdf]/70" />
          </button>
        </div>
      </div>
    </div>
  );
}
